<template>
  <div class="not-prose mb-16 overflow-x-auto">
    <table class="table w-full min-w-full text-left text-blue-950">
      <thead class="text-sm font-normal">
        <tr>
          <th v-for="(col, idx) in data.table.columns" :key="idx" class="p-5">
            {{ col }}
          </th>
        </tr>
      </thead>
      <tbody class="text-base">
        <tr
          v-for="(row, idx) in data.table.data"
          :key="idx"
          :class="idx % 2 === 0 ? 'bg-light-gray' : 'bg-white'"
        >
          <td v-for="(value, jdx) in row" :key="jdx" class="p-5">
            {{ value }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup lang="ts">
import type { TableRecord } from '~/types/generated'

defineProps({
  data: {
    type: Object as PropType<TableRecord>,
    default: () => {}
  }
})
</script>
